/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_PLAN_TYPE_DATA = "GET_PLAN_TYPE_DATA";
export const GET_COMMON_DROPDOWN_DATA = "GET_COMMON_DROPDOWN_DATA";
export const GET_QUARTER_DATA = "GET_QUARTER_DATA";
export const GET_MANUFACTURER_DATA = "GET_MANUFACTURER_DATA";
export const GET_CHECK_DETAILS = "GET_CHECK_DETAILS";
export const HANDLE_ERROR_MSG_CBI = "HANDLE_ERROR_MSG_CBI";
export const SELECTED_REBATE_PROGRAM = "SELECTED_REBATE_PROGRAM";
export const QTR_VALUE = "QTR_VALUE";
export const QTR_VALUE_FOR_API = "QTR_VALUE_FOR_API";
export const SEARCH_DISABLED = "SEARCH_DISABLED";
export const ROW_SELECTED = "ROW_SELECTED";
export const CLEAR_REDUX = "CLEAR_REDUX";
